import React, { useState, useEffect, useRef } from "react";

import "./dropDownButton.scss";
const DropDownButton = ({ children, icon }) => {
  const [active, setActive] = useState(false);
  const wrapperRef = useRef(null);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setActive(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(wrapperRef);

  return (
    <div className="dropdownButonContainer" ref={wrapperRef}>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setActive(!active);
        }}
        className="add-icon-container"
      >
        {icon}
      </div>

      <div className={`slide-card ${active ? "active" : ""}`}>
        <div className="inner-card" onClick={() => setActive(false)}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DropDownButton;
